import { createContext, ReactNode, useContext, useMemo, useState } from 'react'

interface ITileContextData {
  isChecked: boolean
  setIsChecked: React.Dispatch<React.SetStateAction<boolean>>
  isSelectEnabled: boolean
  isSelectable: boolean
}

interface IProps {
  children: ReactNode
  isSelectEnabled: boolean
  isSelectable: boolean
}

const TileContext = createContext<ITileContextData>({} as ITileContextData)

const TileProvider = ({ children, isSelectEnabled, isSelectable }: IProps) => {
  const [isChecked, setIsChecked] = useState(false)

  const value = useMemo(
    () => ({
      isChecked,
      setIsChecked,
      isSelectEnabled,
      isSelectable,
    }),
    [isChecked, isSelectEnabled, isSelectable],
  )

  return <TileContext.Provider value={value}>{children}</TileContext.Provider>
}

const useTileContext = () => {
  const context = useContext(TileContext)

  if (!context) {
    throw new Error(
      'useTileContext must be used within a SearchContextProvider',
    )
  }

  return context
}

export { TileProvider, useTileContext }
